import fileDownload from "js-file-download";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { ERROR_MSG } from "../../../constants/common";
import { RESET_LOADER, SET_LOADER } from "../../../constants/contexConstant";
import {
    ADMIN_DOWNLOAD_RECIEPT,
    GET_PENDING_INVESTMENT_PAYMENTS,
    PAYMENT_APPROVAL_API,
} from "../../../constants/routes";
import { useContextState } from "../../../context/ContextProvider";
import request from "../../../services/request";
import Container from "../../../shared/Container";
import P from "../../../shared/typography/P";
import DrawerAndModalWrapper from "../../../shared/ui/Drawer/DrawerAndModalWrapper";
import LinedTab from "../../../shared/ui/tab/LinedTab";
import InvestmentConfirmationCard from "./InvestmentConfirmationCard";
import PaymentConfirmationCard from "./PaymentConfirmationCard";
import PaymentForm from "./PaymentForm";

const PaymentConfirmation = () => {
    const [currentTab, setCurrentTab] = useState(0);
    const [allPendingPayments, setAllPendingPayments] = useState([]);
    const { dispatch } = useContextState();
    const [selected, setSelected] = useState({});
    const [open, setOpen] = useState(false);
    const [allPendingInvestments, setAllPendingInvestments] = useState([]);
    const handleTabClick = (val) => {
        setCurrentTab(val);
    };

    const handleApprove = async (values) => {
        try {
            dispatch({ type: SET_LOADER });
            let reqData = {
                type:
                    currentTab === 0 ? "CustomerPayment" : "InvestmentPayment",
                id:
                    currentTab === 0
                        ? selected?.paymentId
                        : selected?.investmentId,
                amount: values?.paymentReceived,
                status: values?.paymentStatus,
            };
            await request.authPut({
                endpoint: PAYMENT_APPROVAL_API,
                body: reqData,
            });
            dispatch({ type: RESET_LOADER });
            toast.success("success");
            setOpen((prev) => !prev);
            setSelected({});
        } catch (error) {
            toast.error(typeof error === "string" ? error : ERROR_MSG);
            dispatch({ type: RESET_LOADER });
        }
    };
    const handleDownloadReceipt = async (item) => {
        try {
            dispatch({ type: SET_LOADER });

            const id =
                currentTab === 0
                    ? item?.documentId
                    : item?.investmentDocumentId;

            let res = await request.authGet({
                endpoint: `${ADMIN_DOWNLOAD_RECIEPT}/${id}`,
                checkStatusCode: true,
            });
            let file = await res.blob();
            const mimeType = file.type;
            const extension = mimeType ? mimeType.split("/")[1] : "bin";

            const filename =
                res?.headers?.get("x-custom-filename") ||
                `reciept.${extension}`;

            fileDownload(file, filename);
            dispatch({ type: RESET_LOADER });
        } catch (error) {
            console.log("err", error);
            toast.error(typeof error === "string" ? error : ERROR_MSG);
            dispatch({ type: RESET_LOADER });
        }
    };
    const getPaymentsAndInvestments = async () => {
        try {
            dispatch({ type: SET_LOADER });
            let res = await request.authGet({
                endpoint: GET_PENDING_INVESTMENT_PAYMENTS,
            });
            let response = res?.data?.data;
            if (response) {
                setAllPendingInvestments(response?.allPendingInvestments);
                setAllPendingPayments(response?.allPendingPayments);
            }
            dispatch({ type: RESET_LOADER });
            setSelected({});
        } catch (error) {
            toast.error(typeof error === "string" ? error : ERROR_MSG);
            dispatch({ type: RESET_LOADER });
        }
    };

    useEffect(() => {
        getPaymentsAndInvestments();
    }, []);

    return (
        <>
            <Container className="bg-blue-700 pt-[7rem] lg:py-[10rem] mx-0 px-0 min-w-full  lg:container lg:overflow-y-scroll   min-h-screen  lg:h-full md:bg-white">
                <Container className="rounded-t-2 mt-5 pt-2  mx-0 flex-1 min-h-screen bg-white min-w-full flex flex-col overflow-hidden ">
                    <div className="flex items-center w-full   border-b border-b-blue-200 mb-1.5">
                        <LinedTab
                            className="pb-0  mt-0 pt-0 w-full items-center"
                            activeClass={
                                "text-blue text-nowrap font-medium  duration-300 w-full"
                            }
                            inActiveClass={"text-gray-370 text-nowrap w-full "}
                            data={["Consumer Payment", "Commune Payment"]}
                            activeTab={currentTab}
                            onClick={handleTabClick}
                        />
                    </div>

                    <div className=" flex-1 overflow-auto  text-base no-scrollbar scroll-smooth pb-6 lg:pb-0">
                        <div>
                            {currentTab === 1 ? (
                                <>
                                    {allPendingInvestments?.length > 0 ? (
                                        allPendingInvestments
                                            .sort((a, b) => b?.date - a?.date)
                                            .map((investment, index) => (
                                                <React.Fragment key={index}>
                                                    <InvestmentConfirmationCard
                                                        item={investment}
                                                        handleApprove={() => {
                                                            setOpen(
                                                                (prev) => !prev
                                                            );
                                                        }}
                                                        handleDownloadReceipt={
                                                            handleDownloadReceipt
                                                        }
                                                        setSelected={
                                                            setSelected
                                                        }
                                                    />
                                                    {index !==
                                                        allPendingInvestments.length -
                                                            1 && (
                                                        <hr className=" hidden lg:block my-2 border-blue-300" />
                                                    )}
                                                </React.Fragment>
                                            ))
                                    ) : (
                                        <div className="w-full flex justify-center items-center">
                                            <P className="text-gray-120 font-semibold">
                                                No Commune Payment Available
                                            </P>
                                        </div>
                                    )}
                                </>
                            ) : (
                                <>
                                    {allPendingPayments?.length > 0 ? (
                                        allPendingPayments
                                            .sort((a, b) => b?.date - a?.date)
                                            .map((payment, index) => (
                                                <React.Fragment key={index}>
                                                    <PaymentConfirmationCard
                                                        item={payment}
                                                        handleApprove={() => {
                                                            setOpen(
                                                                (prev) => !prev
                                                            );
                                                        }}
                                                        handleDownloadReceipt={
                                                            handleDownloadReceipt
                                                        }
                                                        setSelected={
                                                            setSelected
                                                        }
                                                    />
                                                    {index !==
                                                        allPendingPayments.length -
                                                            1 && (
                                                        <hr className=" hidden lg:block my-2 border-blue-300" />
                                                    )}
                                                </React.Fragment>
                                            ))
                                    ) : (
                                        <div className="w-full flex justify-center items-center">
                                            <P className="text-gray-120 font-semibold">
                                                No Consumer Payment Available
                                            </P>
                                        </div>
                                    )}
                                </>
                            )}
                        </div>
                    </div>
                </Container>
            </Container>
            <DrawerAndModalWrapper
                isOpen={open}
                onClose={() => setOpen((prev) => !prev)}
                modalContentClass="bg-white"
                drawerContentClassName="min-h-[55vh] rounded-t-4 bg-white"
                drawerClassName="z-[102]"
            >
                <PaymentForm
                    handleApprove={handleApprove}
                    amount={
                        currentTab === 0
                            ? selected?.paymentAmount
                            : selected?.investmentAmount
                    }
                    status={
                        currentTab === 0
                            ? selected?.paymentStatus || "PENDING"
                            : selected?.status || "PENDING"
                    }
                />
            </DrawerAndModalWrapper>
        </>
    );
};

export default PaymentConfirmation;
